// Nhân viên đăng nhập lần đầu bằng mật khẩu tạm chủ đơn vị đặt (docs/KE_HOACH_THANH_VIEN_DON_VI.md): phải đặt mật khẩu
// mới chỉ mình biết rồi mới vào làm việc. Máy chủ cũng chặn mọi chức năng tới khi đổi (403 auth.must_change_password).

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { AuthStage, AuthTitle } from '@/components/auth/AuthStage'
import { AuthError, AuthPassword, AuthSubmit } from '@/components/auth/AuthFields'
import { PasswordCriteria } from '@/components/ui/PasswordCriteria'
import { changePassword, logout } from '@/lib/auth'

export function ForcePasswordChange() {
  const nav = useNavigate()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirmNext, setConfirmNext] = useState('')
  const [valid, setValid] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    if (!valid) return setError('Mật khẩu mới chưa đủ 5 điều kiện bảo mật')
    if (next !== confirmNext) return setError('Mật khẩu nhập lại không khớp')
    if (next === current) return setError('Mật khẩu mới phải khác mật khẩu tạm')
    setBusy(true)
    try {
      await changePassword(current, next)
      toast.success('Đã đổi mật khẩu — chào mừng bạn')
    } catch (err) {
      setError((err as Error)?.message || 'Không đổi được mật khẩu')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthStage>
      <form onSubmit={submit} noValidate>
        <AuthTitle>Đặt mật khẩu của bạn</AuthTitle>
        <AuthPassword id="fp-current" label="Mật khẩu tạm" autoComplete="current-password" value={current} onChange={setCurrent} />
        <AuthPassword id="fp-new" label="Mật khẩu mới" value={next} onChange={setNext}>
          {next.length > 0 && <PasswordCriteria password={next} onValidChange={setValid} className="mt-2" />}
        </AuthPassword>
        <AuthPassword id="fp-confirm" label="Nhập lại mật khẩu mới" value={confirmNext} onChange={setConfirmNext} />
        {error && <AuthError>{error}</AuthError>}
        <AuthSubmit busy={busy} busyLabel="Đang lưu…" disabled={!current || !next || !confirmNext}>Lưu</AuthSubmit>
      </form>
      <div className="lg-actions">
        <button
          type="button"
          className="lg-link lg-link-muted"
          onClick={async () => {
            await logout()
            nav('/login', { replace: true })
          }}
        >
          Đăng xuất
        </button>
      </div>
    </AuthStage>
  )
}
